import React from "react";
import { Modules_Students } from "./Modules_Students";

export const StudentModules = () => {
    return <Modules_Students />;
};
